module.exports = __webpack_public_path__ + "static/media/arrow-left.33a10f76.svg";